import { computed } from 'vue'

import { COUNTRY_CALLING_CODES } from '@/constants/countryCallingCodes'

/**
 * 回傳國際電話區號列表。
 */
export function useCountryCallingCodeOptions() {
  // NOTE: 為保留多語系的彈性，在這裡使用 computed()，確保未來能響應語系變化改變 `name` 的資料。
  return computed(() => {
    const currencyNames = new Intl.DisplayNames(navigator.languages, {
      type: 'region',
    })
    return COUNTRY_CALLING_CODES.map(country => {
      const name = currencyNames.of(country.code) ?? country.code
      return {
        ...country,
        label: `${name} (${country.prefix})`,
        value: country.code,
      }
    })
  })
}
